import { z } from 'zod'
import { responseSchema } from '@/core/types/Response.ts'
import { QRImageDataSchema } from '@/modules/sales/clients/types/QRImageData.ts'

export const qrImageDataApiValidationResponseSchema =
  responseSchema(QRImageDataSchema)

export type QRImageDataApiValidationResponse = z.infer<
  typeof qrImageDataApiValidationResponseSchema
>
